/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react';
import { withSuspense } from '@/modules/global-components/ui/suspense/withSuspense';
import AccessDeniedPage from '@/modules/auth/access/AccessDeniedPage';
import NotFoundPage from '@/modules/global-components/not-found';

const BankAccounts = lazy(
  () => import('@/modules/masters/bank-accounts/BankAccounts'),
);

const Dealers = lazy(() => import('@/modules/masters/dealers/Dealers'));

const FreightCharges = lazy(
  () => import('@/modules/masters/freight-charges/FreightCharges'),
);

const InspectionCharges = lazy(
  () => import('@/modules/masters/inspection-charges/InspectionCharges'),
);

const ForwarderCharges = lazy(
  () =>
    import('@/modules/masters/logistics/forwarder-charges/ForwardersCharges'),
);

const Forwarders = lazy(
  () => import('@/modules/masters/logistics/forwarders/Forwarders'),
);

const InspectionCompanies = lazy(
  () =>
    import('@/modules/masters/logistics/inspection-companies/InspectionCompanies'),
);

const Locations = lazy(
  () => import('@/modules/masters/logistics/locations/Locations'),
);

const TransportCompanies = lazy(
  () =>
    import('@/modules/masters/logistics/transport-companies/TransportCompanies'),
);

const Sellers = lazy(() => import('@/modules/masters/sellers/Sellers'));
const Roles = lazy(() => import('@/modules/masters/roles/ListRoles'));
const UserListing = lazy(() => import('@/modules/masters/users/userListing'));
const MastersLayout = lazy(() => import('@/modules/masters/MastersLayout'));
const masterVoyages = lazy(
  () => import('@/modules/masters/shipping/voyages/Voyages'),
);
const masterMakeModel = lazy(
  () => import('@/modules/masters/makeModel/MakeModel'),
);
const masterAuctionHouses = lazy(
  () => import('@/modules/masters/auctionHouses/AuctionHouses'),
);
const ShippingCompanies = lazy(
  () => import('@/modules/masters/shipping/companies/ShippingCompanies'),
);
const ShippingAgents = lazy(
  () => import('@/modules/masters/shipping/agents/ShippingAgents'),
);
export const masterRoutes = [
  {
    path: 'masters',
    element: withSuspense(MastersLayout),
    children: [
      {
        path: 'carriers/make-model',
        element: withSuspense(masterMakeModel),
      },
      {
        path: 'carriers/auction-houses',
        element: withSuspense(masterAuctionHouses),
      },
      {
        path: 'carriers/dealers',
        element: withSuspense(Dealers),
      },
      {
        path: 'carriers/sellers',
        element: withSuspense(Sellers),
      },
      {
        path: 'logistic/locations',
        element: withSuspense(Locations),
      },
      {
        path: 'logistic/inspection-companies',
        element: withSuspense(InspectionCompanies),
      },
      {
        path: 'logistic/inspection-charges',
        element: withSuspense(InspectionCharges),
      },
      {
        path: 'logistic/transport-companies',
        element: withSuspense(TransportCompanies),
      },
      {
        path: 'logistic/transport-charges',
        element: withSuspense(() => <>transport-charges Page</>),
      },
      {
        path: 'shipping/voyages',
        element: withSuspense(masterVoyages),
      },
      {
        path: 'shipping/freight-charges',
        element: withSuspense(FreightCharges),
      },
      {
        path: 'shipping/forwarders',
        element: withSuspense(Forwarders),
      },
      {
        path: 'shipping/forwarder-charges',
        element: withSuspense(ForwarderCharges),
      },
      {
        path: 'shipping/shipping-agents',
        element: withSuspense(ShippingAgents),
      },
      {
        path: 'shipping/shipping-companies',
        element: withSuspense(ShippingCompanies),
      },
      {
        path: 'shipping/location-forwarders',
        element: withSuspense(() => <>location-forwarders Page</>),
      },
      {
        path: 'direct-masters/roles',
        element: withSuspense(Roles),
      },
      {
        path: 'direct-masters/users',
        element: withSuspense(UserListing),
      },
      {
        path: 'direct-masters/bank-accounts',
        element: withSuspense(BankAccounts),
      },
      {
        path: 'access',
        element: (
          <AccessDeniedPage className="min-h-none min-w-none size-full" />
        ),
      },
      {
        path: '*',
        element: <NotFoundPage className="min-h-none min-w-none size-full" />,
      },
    ],
  },
];
